import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { Rubric } from '../../models/Legal/Rubric';

const LEGAL_HOST = process.env.REACT_APP_LEGAL_HOST;
const LEGAL_KEY = process.env.REACT_APP_LEGAL_KEY;

export const GET_RUBRICS_REQUEST = 'LEGAL_GET_RUBRICS_REQUEST';
export const GET_RUBRICS_RESPONSE = 'LEGAL_GET_RUBRICS_RESPONSE';
export const GET_RUBRICS_ERROR = 'LEGAL_GET_RUBRICS_ERROR';

export const GET_TEMPLATES_REQUEST = 'LEGAL_GET_TEMPLATES_REQUEST';
export const GET_TEMPLATES_RESPONSE = 'LEGAL_GET_TEMPLATES_RESPONSE';
export const GET_TEMPLATES_ERROR = 'LEGAL_GET_TEMPLATES_ERROR';

export const SET_RUBRIC = 'LEGAL_SET_RUBRIC';

export const getRubricsAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_RUBRICS_REQUEST,
    });

    try {
        const response = await fetcher(`${LEGAL_HOST}/api/v1/rubrics`)
            .auth(`Basic ${LEGAL_KEY}`)
            .json();

        dispatch({
            type: GET_RUBRICS_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_RUBRICS_ERROR,
            error,
        });
    }
};

export const getTemplatesAction = (rubricId: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_TEMPLATES_REQUEST,
    });

    try {
        const response = await fetcher(`${LEGAL_HOST}/api/v1/templates?rubric_id=${rubricId}`)
            .auth(`Basic ${LEGAL_KEY}`)
            .json();

        dispatch({
            type: GET_TEMPLATES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_TEMPLATES_ERROR,
            error,
        });
    }
};

export const setRubricAction = (rubric: Rubric) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_RUBRIC,
        rubric,
    });
};



// WEBPACK FOOTER //
// ./src/actions/Legal/legal.ts